import {useTransition} from '@yandex-delivery/blocks'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {getUUID} from '@yandex-delivery/utils'
import {useState} from 'react'
import {useLocation} from 'react-router-dom'
import {type ActionOpenRover, fetchOpenRoverAndEventPolling, fetchSharedRouteInfo} from 'src/api'

import {useSharedRoute} from '../../hooks'
import type {RouterParams} from '../../types'

export function useOpenRover(action: ActionOpenRover) {
  const location = useLocation<RouterParams>()
  const key = location.hash.substring(1)
  const [revisionEvent, setRevisionEvent] = useState<number>(0)

  const [, startRouteTransition] = useSharedRoute()
  const [{isPending}, startTransition] = useTransition<void, ServerError>(undefined, {
    key: 'shared-route/rover-action',
  })

  function openRoverHandler(onSendOpenCommand?: VoidFunction) {
    const requestId = getUUID()

    startTransition(
      () =>
        fetchOpenRoverAndEventPolling(
          {
            key,
            request_id: requestId,
            action: action.action,
            payload: action.payload,
          },
          revisionEvent,
          onSendOpenCommand,
        ).then(response => {
          setRevisionEvent(response.revision)
          if (response.message) {
            throw new Error(response.message.dialog?.title ?? 'Не получилось открыть крышку')
          }
        }),
      {
        onCommit() {
          startRouteTransition(() => fetchSharedRouteInfo({key}))
        },
      },
    )
  }

  return {
    isPending,
    openRoverHandler,
  } as const
}
